module.exports = __webpack_public_path__ + "img/96.50de89e5.png";